import {
  LocaleFeaturedLink,
  LocaleNavbarTab,
  LocaleNavbarTabLink,
  LocaleNavbarTabSection,
  NavbarTab,
} from 'typescriptDefs/layout';

import { TLocale } from 'utils/i18n';

export const localizeNavigationLinks = ({
  locale,
  tabs,
  searchParams = '',
}: {
  locale: TLocale;
  tabs: NavbarTab[];
  searchParams: string | undefined;
}): LocaleNavbarTab[] => {
  const isFr = locale === 'fr';
  const tabsToReturn = tabs
    .map((tab) => {
      const featuredLink = tab.featured;
      const hasValidFeaturedLink = featuredLink && ((isFr && !!featuredLink.frTitle) || !!featuredLink.enTitle);
      const frLink = featuredLink?.frUrl || `/fr${featuredLink?.enUrl}`;
      return {
        title: isFr ? tab.frTitle : tab.enTitle,
        featured: (hasValidFeaturedLink
          ? {
              title: isFr ? featuredLink.frTitle : featuredLink.enTitle,
              description: isFr ? featuredLink.frDescription : featuredLink.enDescription,
              url: (isFr ? frLink : featuredLink.enUrl) + searchParams,
              linkText: isFr ? featuredLink.frLinkText : featuredLink.enLinkText,
              image: featuredLink.image,
            }
          : null) as LocaleFeaturedLink,
        content: tab.content
          .map((section) => {
            if (section._type === 'siteNavigationLink') {
              const frLink = section.frUrl || `/fr${section.enUrl}`;
              return {
                title: isFr ? section.frTitle : section.enTitle,
                description: isFr ? section.frDescription : section.enDescription,
                url: (isFr ? frLink : section.enUrl) + searchParams,
                isNew: section.isNew,
                image: section.image,
                _type: section._type,
              } as LocaleNavbarTabLink;
            } else {
              return {
                title: isFr ? section.frTitle : section.enTitle,
                description: isFr ? section.frDescription : section.enDescription,
                alignVertically: section.alignVertically,
                _type: section._type,
                links: section.links
                  .map((link) => {
                    const frLink = link.frUrl || `/fr${link.enUrl}`;
                    return {
                      title: isFr ? link.frTitle : link.enTitle,
                      description: isFr ? link.frDescription : link.enDescription,
                      url: (isFr ? frLink : link.enUrl) + searchParams,
                      isNew: link.isNew,
                    };
                  })
                  .filter((link) => !!link.title),
              } as LocaleNavbarTabSection;
            }
          })
          .filter((section) => !!section.title),
      };
    })
    .filter((tab) => !!tab.title);

  return tabsToReturn;
};
